import { DocumentTagEnum } from "../../../../../../types/enums";
import { UndoableTag } from "../../../../../../components/general/UndoableTag";

const BASE_CLASSES = "rounded-md px-2 py-0.5 text-xs font-medium leading-5";

const TAG_STYLES: Record<string, { label: string; toneClasses: string }> = {
    [DocumentTagEnum.PRIVATELY_PAID]: {
        label: "Privé betaald",
        toneClasses: "bg-[#E8DEEE] text-[#5B3A8C]",
    },
    [DocumentTagEnum.MATCHED]: {
        label: "Match",
        toneClasses: "bg-[#FDECC8] text-[#6B4C13]",
    },
    [DocumentTagEnum.WRITE_OFF]: {
        label: "Afschrijven",
        toneClasses: "bg-[#D3E5EF] text-[#1C3D5A]",
    },
    [DocumentTagEnum.FIXED_ASSET]: {
        label: "Activum",
        toneClasses: "bg-[#DBEDDB] text-[#1C3829]",
    },
};

interface Props {
    tags: string[];
    onUndoPrivatelyPaid?: () => void;
    onFixedAssetClick?: () => void;
}

export default function TableTags({ tags, onUndoPrivatelyPaid, onFixedAssetClick }: Props) {
    return <div className="flex flex-wrap items-center gap-1.5">
        {tags.map((tag) => {
            const style = TAG_STYLES[tag];
            if (!style) {
                return null;
            }

            if (tag === DocumentTagEnum.PRIVATELY_PAID) {
                return <UndoableTag key={tag}
                    label={style.label}
                    undoLabel="Privé betaald ongedaan maken"
                    testId="privately-paid-tag"
                    className={`${BASE_CLASSES} ${style.toneClasses} pr-0.5`}
                    onUndoClick={onUndoPrivatelyPaid} />;
            }

            if (tag === DocumentTagEnum.FIXED_ASSET && onFixedAssetClick) {
                return <button key={tag}
                    type="button"
                    data-testid="fixed-asset-tag"
                    onClick={(event) => {
                        event.stopPropagation();
                        onFixedAssetClick();
                    }}
                    className={`inline-flex items-center whitespace-nowrap ${BASE_CLASSES} ${style.toneClasses} hover:opacity-80`}>
                    {style.label}
                </button>;
            }

            return <span key={tag}
                className={`inline-flex items-center whitespace-nowrap ${BASE_CLASSES} ${style.toneClasses}`}>
                {style.label}
            </span>;
        })}
    </div>;
}
